import React, { useState } from 'react';
import { Section } from './Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export const FAQ = () => {
  const faqs = [{
    q: '¿Alguien se va a dar cuenta de lo que hago?',
    a: 'No. Son rituales mentales y gestos cotidianos que pasan totalmente desapercibidos.'
  }, {
    q: '¿Sirve para Home Office?',
    a: "Especialmente. Ayuda a separar el espacio de 'trabajo' del espacio de 'vida' cuando todo ocurre en el mismo living."
  }, {
    q: '¿Cómo pago desde Argentina?',
    a: 'Aceptamos todos los medios de pago locales en pesos (Mercado Pago, transferencia) y tarjeta de crédito.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-navy-900/30 border-y border-gold/10" data-id="element-51">
      <div className="max-w-3xl mx-auto" data-id="element-52">
        <h2 className="text-3xl md:text-4xl font-serif text-center mb-12" data-id="element-53">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-54">
          {faqs.map((faq, i) => <div key={i} className="border border-gold/20 rounded-sm overflow-hidden bg-navy-800/50" data-id="element-55">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-navy-800 transition-colors" data-id="element-56">
                <span className="font-serif text-lg text-offwhite" data-id="element-57">
                  {faq.q}
                </span>
                <ChevronDown className={`text-gold transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} size={20} data-id="element-58" />
              </button>

              <AnimatePresence data-id="element-59">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-60">
                    <div className="px-6 pb-5 pt-2 text-gray-400 font-light border-t border-gold/10" data-id="element-61">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
};